import React from "react";
import "../css/arrival.css";
import { checkedData } from "../rawData/MenuData";

const PriceList = () => {
  return (
    <>
      <div className="sideBox">
        <ul className="border-top ">
          <button
            className="brandbtn"
            type="button"
            data-toggle="collapse"
            data-target="#price"
          >
            Price
          </button>
          <div id="price" class="collapse">
            <form>
              <div class="form-group">
                <input
                  type="text"
                  placeholder="Search item"
                  className="form-control"
                />
              </div>
              <div>
                <ul>
                  {checkedData.map((value) => (
                    <li>
                      <a>
                        <input type="checkbox" className="mr-2" />
                        <span>{value.span} </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </form>
          </div>
        </ul>
      </div>
    </>
  );
};

export default PriceList;
